import { AuthService } from './../../../../service/auth.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faKey, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { Callback } from '../../login.component';
import { AgentDto } from '../../../../service/dto';

@Component({
    selector: 'app-rejected',
    templateUrl: './rejected.component.html',
    styleUrl: './rejected.component.scss',
    standalone: false
})
export class RejectedComponent {
	@Input() agent!: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();

}
